import { Paper } from '@mui/material';
import { MenuAppBar, PageLoader, isOperatorRole } from 'remote/global';
import { Box } from '@mui/system';
import AccountInvitationRegistrationForm from 'components/forms/AccountFactory/AccountInvitationRegistrationForm';
import { Navigate, useParams } from 'react-router-dom';
import { useUIDrawer } from 'api/queries/ui';
import { useLanguageMenuItems } from 'utils/hooks/useMenuItems';
import { useInvitationsStatusQuery } from 'api/queries/invitations';
import { ROUTES } from 'utils/data/routes';
import { TokenStatus } from 'utils/data/enums';
import easLogo from '../assets/EAS_SF_RGB_ENG.webp';

function AccountInvitationRegistrationView() {
  const { setIsMobileDrawerOpen } = useUIDrawer();
  const { id } = useParams();
  const langMenuItems = useLanguageMenuItems();
  const { data: invitationStatus, isLoading, isError } = useInvitationsStatusQuery(id);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        <PageLoader />
      </Box>
    );
  }

  if (isError || invitationStatus?.status !== TokenStatus.OK) {
    return <Navigate to={ROUTES.BaseRoutes.ROOT} replace />;
  }

  if (invitationStatus?.role != null && !isOperatorRole(invitationStatus.role)) {
    return <Navigate to={ROUTES.BaseRoutes.ROOT} replace />;
  }

  return (
    <>
      <MenuAppBar
        env={window.MOBIFER_ENV}
        menuItems={langMenuItems}
        // Because AccountInvitationRegistrationView assumes, that there is no user, we can not update the language in DB
        onLanguageChange={() => {}}
        setIsMobileDrawerOpen={setIsMobileDrawerOpen}
      />
      <Box sx={{ py: '5rem', px: 2, maxWidth: ['500px', '500px', '800px', '900px'], mx: 'auto' }}>
        <Paper elevation={3} sx={{ p: [3, 4, 6] }}>
          <AccountInvitationRegistrationForm defaultEmail={invitationStatus?.email ?? ''} />
        </Paper>
        <Box
          sx={{
            position: 'absolute',
            right: '0.5rem',
            bottom: '0.5rem',
            zIndex: -1,
          }}
        >
          <img
            style={{
              width: '100%',
              maxWidth: '300px',
            }}
            alt='EAS logo'
            src={easLogo}
          />
        </Box>
      </Box>
    </>
  );
}

export default AccountInvitationRegistrationView;
